import './SearchBox.css'

import { useEffect, useRef } from 'react'
import { useState } from 'react'
import useSearchingResults from './Hooks/useSearchingResults'
import SearchBoxList from './SearchBoxList'
import { useTranslation } from 'react-i18next'
import { FaMagnifyingGlass } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom'
import LoadingSpinner from '../Components/LoadingSpinner'
import { useShop } from '../../Providers/ShopProvider'
import { useParams } from '../../Providers/ParamsProvider'
import { RxCross2 } from "react-icons/rx";

const SearchBox = () => {
  const inputRef = useRef(null)
  const { handleGetProductsFromSearchingBar, productsFilter, setProductsFilter } = useShop()
  const navigate = useNavigate()
  const [textSearch, setTextSearch] = useState(productsFilter.SearchingQuery ? productsFilter.SearchingQuery : "")
  const [isFocus, setIsFocus] = useState(false);
  const searcherBox = useRef()
  const { t } = useTranslation()
  const { result, loading, products, isProductsLoaded, productsRelatesSuppliers, productsCategories, handleGetSearchingResult } = useSearchingResults(textSearch);
  const { searchingQueryCharNumber } = useParams()

  useEffect(() => {
    if (textSearch && textSearch.length > 0)
      setIsFocus(true)
  }, [textSearch])

  useEffect(() => {
    const handler = (event) => {
      if (!searcherBox.current.contains(event.target)) {
        setIsFocus(false);
      }
    }
    document.addEventListener("mousedown", handler)
    return () => {
      document.removeEventListener("mousedown", handler)
    }
  }, [])

  useEffect(() => {
    setTextSearch(productsFilter.SearchingQuery ? productsFilter.SearchingQuery : "")
  }, [productsFilter.SearchingQuery])

  const handleKeyPress = (event, buttonClick, isGlassButton) => {
    if ((event && event.key === "Enter") || buttonClick) {
      if (buttonClick) { //klikniecie przycisku tylko odświeża produkty w query
        const allArticles = isGlassButton ? productsFilter.AllArticles : true
        setProductsFilter(prev => ({
          ...prev,
          AllArticles: allArticles
        }))
        handleGetSearchingResult(textSearch, allArticles, null)
        inputRef.current?.focus()
        return
      }
      else if (textSearch.length >= searchingQueryCharNumber) {
        handleGetProductsFromSearchingBar(textSearch, buttonClick)

        const params = new URLSearchParams(window.location.search)
        if (textSearch) {
          params.set('q', textSearch)
        } else {
          params.delete('q')
        }
        navigate(`/shop?${params.toString()}`)

        setIsFocus(false)
        inputRef.current?.focus()
      }
    }
  }

  const handleCleatQuery = () => {
    setTextSearch("")
    navigate('/Shop')
  }

  let searchPlaceholderText = searchingQueryCharNumber <= 1 ? t('placeholder_search_box')
    : `${t('placeholder_search_box')} (${t('placeholder_search_box_min')} ${searchingQueryCharNumber} ${t('placeholder_search_box_char')})`;

  return (
    <div ref={searcherBox} style={{ position: 'relative' }}>
      <div className='row searchBox'>
        <div className='searchBox-icon col-auto px-3'>
          <FaMagnifyingGlass size={26} className='primary-accent-color-text element-pointer' onClick={() => handleKeyPress(null, true, true)} />
        </div>
        <input
          ref={inputRef}
          className='col'
          type='text'
          required={true} placeholder={searchPlaceholderText}
          value={textSearch}
          onChange={(e) => setTextSearch(e.target.value)}
          onFocus={() => setIsFocus(true)}
          onKeyDown={(e) => handleKeyPress(e, false, productsRelatesSuppliers)}
        />
        <div className='col-auto d-flex align-items-center justify-content-center'>
          <RxCross2 size={26} className='element-pointer' color='var(--primary)' onClick={() => handleCleatQuery()} />
        </div>
      </div>
      {loading && textSearch.length >= searchingQueryCharNumber && <div className='searchBox-results' style={{ position: 'absolute', left: '-180px', zIndex: 1201 }}>
        <LoadingSpinner />
      </div>}
      {!loading && <div className="searchBox-results" style={{
        position: 'absolute', left: '-180px', zIndex: 1200, visibility: isFocus && textSearch.length >= searchingQueryCharNumber
          && isProductsLoaded ? 'visible' : 'hidden'
      }}>
        <div className='container'>
          <SearchBoxList
            items={result}
            products={products}
            productsRelatesSuppliers={productsRelatesSuppliers}
            setTextSearch={setTextSearch}
            setIsFocus={setIsFocus}
            handleKeyPress={handleKeyPress}
            query={textSearch}
            productsCategories={productsCategories}
          />
        </div>
      </div>}
    </div >
  )
}

export default SearchBox